export const regExForName = new RegExp(/^[\w() -]{3,50}$/);
// eslint-disable-next-line
export const regExForEmail = new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

const regexQuery = '^(https?://)?(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$';

// eslint-disable-next-line
export const regExForUrl = new RegExp(regexQuery,"i");

export const regExForNumber = new RegExp(/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/); //eslint-disable-line

export const regExForTwitter = new RegExp('^(?:https://)?(?:www\\.)?twitter\\.com/(\\w+)$', 'i');

export const regExForInsta = new RegExp(/^\s*(https\:\/\/)??(?:www\\.)instagram\.com\/[a-z\d-_]{1,255}\s*$/i); //eslint-disable-line

export const regExForTwitterHandle = new RegExp(/^@([A-Za-z0-9_]{1,15})$/);

export const regExForTwitterURL = new RegExp(/^https?:\/\/(?:www\.)?twitter\.com\/(?:#!\/)?@?([A-Za-z0-9_]{1,15})(?:\/status\/\d+)?\/?$/);



// WEBPACK FOOTER //
// ./src/common/constants/Regularexpression.js